import { render, staticRenderFns } from "./WhatsappTemplates.vue?vue&type=template&id=0333daea&"
import script from "./WhatsappTemplates.vue?vue&type=script&lang=js&"
export * from "./WhatsappTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0333daea')) {
      api.createRecord('0333daea', component.options)
    } else {
      api.reload('0333daea', component.options)
    }
    module.hot.accept("./WhatsappTemplates.vue?vue&type=template&id=0333daea&", function () {
      api.rerender('0333daea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/WhatsappTemplates.vue"
export default component.exports